export const INITIAL_FILTERS = {
  clubNames: [],
  memberTypes: [],
  districtRoles: [],
  clubIds: [],
};
